import Icon from '../components/Icon.vue'

Icon.register({
  'sort-numeric-up': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M330.2 258.9c53.5-14.3 101.8 25.9 101.8 77.1v10.8c0 70.4-28.3 107.2-86.3 132-8.4 3.6-18-1.3-20.9-9.9l-9.9-20c-2.6-7.9 0.6-16.9 8.2-20.3 6.3-2.7 15.6-8.5 20.8-12.9-47.6-4.8-83.1-51.5-68.8-102.5 6.8-23.5 31.4-47.7 55-54.2zM352 356c11 0 20-9 20-20s-9-20-20-20-20 9-20 20 9 20 20 20zM304 96c-8.8 0-16-7.2-16-16 0-2.1 0.8-5.3 1.7-7.2l16-32c2.4-4.9 8.8-8.8 14.3-8.8h48c8.8 0 16 7.2 16 16v112h16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h16v-64h-16zM107.3 36.7l80 96c10.1 10.1 2.9 27.3-11.3 27.3h-48v304c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-304h-48c-14.2 0-21.3-17.3-11.3-27.3l80-96c2.6-2.6 7.7-4.7 11.3-4.7s8.7 2.1 11.3 4.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sort-numeric-up.js
// module id = 1930
// module chunks = 0